var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3,4)",
    strokeWidth: 0.4,
    d: "M12.75 2.75H15L13.875 4.25L12.75 2.75ZM2.25 0.5H15.75C16.1478 0.5 16.5294 0.658035 16.8107 0.93934C17.092 1.22064 17.25 1.60218 17.25 2V5C17.25 5.8325 16.5825 6.5 15.75 6.5H12V14C12 14.8325 11.3325 15.5 10.5 15.5H2.25C1.85218 15.5 1.47064 15.342 1.18934 15.0607C0.908035 14.7794 0.75 14.3978 0.75 14V2C0.75 1.175 1.425 0.5 2.25 0.5ZM2.25 2V5H10.5V2H2.25ZM15.75 5V2H12V5H15.75ZM2.25 14H10.5V6.5H2.25V14ZM3.75 8H9V9.5H3.75V8ZM3.75 11H9V12.5H3.75V11Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.266e2f7ce81d26552067323fa7c7ccc8.svg";
export { ForwardRef as ReactComponent };